import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chip, esim"} maskId="square-filled-radius-0-stroke-1-IconChip"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM8 20V18H7V20H4V4H7V6H8V4H11.5V6H12.5V4H16V6H17V4H20V20H17V18H16V20H12.5V18H11.5V20H8ZM7 8H17V16H7V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChip;
